module.exports = __webpack_public_path__ + "static/img/logo_black.38658a8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo_black.png
// module id = K6bQ
// module chunks = 1 2 3 4 5 6 7 8 9 10